(function () {
  'use strict';
  /* Pilot: this file is bundled by Shopify's javascript component tag and therefore loads ONCE
     per page even if the section appears multiple times. init() is now per-instance: the section
     id and the three boolean settings come from the root element's data-* attributes, because
     component assets are NOT Liquid-processed. */
  function init(SID) {
    var root  = document.getElementById('ugcv-root-' + SID);
    var track = document.getElementById('ugcv-track-' + SID);
    if (!root || !track) return;
    if (root._ugcvInit) return;   /* guard against double-init on re-entry */
    root._ugcvInit = true;
    root.dataset.ugcvBuild = 'aa-ab-20260728';

    var modal  = document.getElementById('ugcv-modal-' + SID);
    var feed   = document.getElementById('ugcv-feed-' + SID);
    var hoverAP   = root.dataset.ugcvHoverAutoplay === 'true';
    var mobileAP  = root.dataset.ugcvMobileAutoplay === 'true';
    var modalOn   = root.dataset.ugcvModalEnabled === 'true';

    /* First-frame preview is handled by the .ugcv__poster-img overlay —
       no seek needed here. The poster stays visible until 'playing' fires. */

    /* ── Poster overlay: toggle via play/pause events ──────────────────────
       The <img class="ugcv__poster-img"> sits above the <video> in the DOM,
       covering the black loading frame. It stays visible until 'playing' fires,
       then fades out. On pause/leave it reappears without any video.load() call. */
    track.querySelectorAll('.ugcv__card').forEach(function (card) {
      var v   = card.querySelector('.ugcv__video');
      var p   = card.querySelector('.ugcv__poster-img');
      var ico = card.querySelector('.ugcv__play-icon');
      if (!v) return;
      v.addEventListener('playing', function () {
        /* Hide the poster only once a real frame has been PRESENTED — hiding on
           'playing' alone revealed the card background for a beat before the
           first frame painted (user-reported grey flash). The 250ms timeout is a
           fallback for compositors that never deliver rVFC (headless, some
           battery-saver modes): by then a playing video has painted. */
        var done = false;
        var hide = function () {
          if (done) return;
          done = true;
          if (v.paused) return; /* a stale pause landed before the frame */
          if (p)   p.classList.add('is-hidden');
          if (ico) ico.classList.add('is-hidden');
        };
        if (v.requestVideoFrameCallback) v.requestVideoFrameCallback(hide);
        setTimeout(hide, 250);
      });
      v.addEventListener('pause', function () {
        /* Transient pauses of the still-active card (engine power-saving, trigger
           churn) keep the last frame on screen — the watchdog resumes playback.
           The poster only returns on a real deactivation (activeVideo moved on),
           which deactivateVideo/mouseleave arrange before or after pausing. */
        if (activeVideo === v) return;
        if (p)   p.classList.remove('is-hidden');
        if (ico) ico.classList.remove('is-hidden');
      });
    });

    /* JS-gated poster loading is handled by the shared utility
       assets/kore-gated-images.js (img[data-kore-gate-src]) — the local
       observer copy that used to live here was removed. */

    /* ── RTL start: row-reverse places block[0] at physical RIGHT. ──────────
       scrollLeft=0 = physical LEFT in LTR (all browsers agree).
       Setting to scrollWidth clamps to (scrollWidth − clientWidth) in every
       browser → physical rightmost position = block[0] fully visible. */

    /* ── RTL start: scroll to rightmost position (block[0] visible) ─────────── */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        track.scrollLeft = track.scrollWidth;
      });
    });

    /* ── Arrow helpers (left and right) ─────────────────────────────────── */
    var singleLeftArrow  = root.querySelector('.ugcv-single-left-arrow');
    var singleRightArrow = root.querySelector('.ugcv-single-right-arrow');

    /* RTL polarity probe: write -1, check if it sticks negative.
       Chrome spec range: [-(max), 0]; 0 = rightmost.
       Safari legacy range: [0, max]; max = rightmost. */
    var arrowNegRTL = false;
    (function () {
      var s = track.scrollLeft;
      track.scrollLeft = -1;
      arrowNegRTL = track.scrollLeft < 0;
      track.scrollLeft = s;
    })();

    var arrowStep = function () {
      var card = track.querySelector('.ugcv__card');
      return card
        ? card.offsetWidth + (parseFloat(getComputedStyle(track).gap) || 0)
        : track.clientWidth * 0.75;
    };

    var arrowFromStart = function () {
      /* 0 = at rightmost start; positive = scrolled toward hidden videos. */
      var max = track.scrollWidth - track.clientWidth;
      if (max <= 0) return 0;
      return arrowNegRTL ? -track.scrollLeft : max - track.scrollLeft;
    };

    var updateRightArrow = function () {
      if (!singleRightArrow) return;
      var max = track.scrollWidth - track.clientWidth;
      /* Threshold of 8px: smooth scroll + snap may not return to exact 0,
         so we treat anything within 8px of the start as "at start". */
      singleRightArrow.hidden = max <= 1 || arrowFromStart() <= 8;
    };

    if (singleLeftArrow) {
      /* Left arrow unchanged: scroll left one step to reveal more videos. */
      singleLeftArrow.addEventListener('click', function () {
        track.scrollBy({ left: -arrowStep(), behavior: 'smooth' });
      });
    }

    if (singleRightArrow) {
      /* Right arrow: scroll right one step back toward the starting position. */
      singleRightArrow.addEventListener('click', function () {
        track.scrollBy({ left: arrowStep(), behavior: 'smooth' });
      });
    }

    /* Debounced scroll listener covers manual swipe, trackpad scroll,
       and all scrollBy animations — updates right arrow visibility. */
    var arrowScrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(arrowScrollTimer);
      arrowScrollTimer = setTimeout(updateRightArrow, 80);
    }, { passive: true });

    /* scrollend fires after the snap animation fully settles — catches the
       exact resting position more reliably than the debounced scroll alone. */
    if ('onscrollend' in window) {
      track.addEventListener('scrollend', updateRightArrow, { passive: true });
    }

    /* ══ ONE LOCAL MEDIA OWNER ═══════════════════════════════════════════════
       Before this, seven independent paths attached sources, called load(),
       called play() and retried playback: touchstart, touchend, hover, the
       scroll-settle preview, the approach prewarm, the intersection autoplay,
       and the modal (plus adjacent-slide prewarm). Nothing arbitrated between
       them, so an inline card and the MODAL COPY OF THE SAME ASSET could both
       be downloading, and a stale canplay retry could revive a player the user
       had already left.

       Now exactly one <video> in this section owns media activity at a time —
       either an inline card or a modal slide, never both. Ownership is explicit
       and generational: every async callback carries the token it was created
       with and does nothing unless that token is still current. Changing owner
       bumps the generation, which invalidates every retry in flight.

       PAUSE vs RELEASE is now a real distinction (they were conflated):
         pauseVideo()   stop playback, KEEP the buffer — short, deliberate stops
         releaseVideo() stop playback AND abort network work — this player is
                        no longer relevant. pause() alone does NOT stop an HLS
                        fetch; only blanking preload and calling load() does. */
    var OWNER = { gen: 0, state: 'idle', video: null, role: null };
    /* activeVideo is kept as a read-only mirror of the inline owner: the poster
       listeners and the hover handler already read it, and its meaning is
       unchanged ("the card that should be showing video, not poster"). */
    var activeVideo = null;

    /* Asset identity is separate from player identity: the same Shopify video id
       appears on a card AND on its modal slide, and two players of one asset are
       still duplicate media activity. */
    function assetIdOf(v) {
      if (!v) return null;
      if (v._ugcvAsset) return v._ugcvAsset;
      var srcs = v.querySelectorAll('source');
      for (var i = 0; i < srcs.length; i++) {
        var u = srcs[i].getAttribute('src') || srcs[i].getAttribute('data-src') || '';
        var m = /\/vp\/([a-f0-9]{32})\//.exec(u);
        if (m) { v._ugcvAsset = m[1]; return m[1]; }
      }
      return null;
    }
    function playerIdOf(v) {
      if (!v) return null;
      if (v._ugcvPid) return v._ugcvPid;
      var slide = v.closest('.ugcv-modal__slide');
      var card  = v.closest('.ugcv__card');
      var host  = slide || card;
      var role  = slide ? 'modal' : (card ? 'card' : 'other');
      var idx   = host && host.dataset ? (host.dataset.ugcvIdx != null ? host.dataset.ugcvIdx : '?') : '?';
      var clone = host && host.hasAttribute && host.hasAttribute('data-ugcv-clone') ? 'c' : '';
      v._ugcvPid = role + idx + clone;
      return v._ugcvPid;
    }

    function dbg() {}                     /* diagnostics removed for release */
    function assertNoDuplicateAsset() {}  /* was a test-only invariant recorder */

    /* "Is this element doing media work worth aborting?" Used by releaseVideo to skip
       the load() on a player that holds nothing, so an untouched card is never churned. */
    function netActive(v) {
      if (!v) return false;
      if (!v.querySelectorAll('source[src]').length && !v.getAttribute('src')) return false;
      return v.networkState === 2 || v.readyState > 0;
    }

    function setOwner(video, role, state) {
      OWNER.gen++;
      OWNER.video = video || null;
      OWNER.role  = video ? role : null;
      OWNER.state = video ? state : 'idle';
      activeVideo = (video && role === 'inline') ? video : null;
      var tok = { gen: OWNER.gen, video: video || null };
      if (video) video._ugcvToken = tok;
      dbg('own:' + OWNER.state, video, role);
      return tok;
    }
    /* Every async continuation must pass this before touching media. */
    function isCurrent(tok) {
      return !!tok && tok.gen === OWNER.gen && OWNER.video === tok.video;
    }

    function loadVideoSources(video) {
      if (video._sourcesLoaded) return;
      video._sourcesLoaded = true;
      if (video.dataset.poster && !video.getAttribute('poster')) {
        video.setAttribute('poster', video.dataset.poster);
      }
      video.querySelectorAll('source[data-src]').forEach(function (s) {
        s.setAttribute('src', s.getAttribute('data-src'));
        s.setAttribute('type', s.getAttribute('data-type'));
      });
      dbg('sources', video);
    }

    function restorePosterFor(v) {
      var card = v.closest('.ugcv__card');
      if (!card) return;
      var p   = card.querySelector('.ugcv__poster-img');
      var ico = card.querySelector('.ugcv__play-icon');
      if (p)   p.classList.remove('is-hidden');
      if (ico) ico.classList.remove('is-hidden');
    }

    /* Stop playback, keep the buffer. Only for short deliberate stops where the
       same player is likely to resume and holding the buffer costs nothing. */
    function pauseVideo(v) {
      if (!v) return;
      try { v.pause(); } catch (e) {}
      dbg('pause', v);
    }

    /* Stop playback AND abort network work: this player is no longer relevant.
       The <source src> attributes are deliberately LEFT IN PLACE — load() with a
       blanked preload aborts the fetch while keeping the element fully
       recoverable, which is what lets a released card resume when the modal
       closes or the user scrolls back. */
    function releaseVideo(v) {
      if (!v) return;
      v._ugcvToken = null;               /* invalidates every retry in flight for this element */
      if (v._hoverPlay)  { v.removeEventListener('canplay', v._hoverPlay);  v._hoverPlay = null; }
      if (v._ugcvRetry)  { v.removeEventListener('canplay', v._ugcvRetry);  v._ugcvRetry = null; }
      v._koreInlineLoadPending = false;
      v._koreLoadPending = false;
      var wasActive = netActive(v) || !v.paused;
      try { v.pause(); } catch (e) {}
      if (v.readyState >= 1) { try { v.currentTime = 0; } catch (e) {} }
      restorePosterFor(v);
      if (!wasActive) { dbg('release:noop', v); return; }  /* nothing on the wire to abort */
      /* Release = detach the media sources, then load(). Resource selection finds
         nothing, so the element holds no media and WebKit has nothing to repopulate:
         measured 0.00s retained inline buffer across 10/10 modal-ownership periods,
         versus 2.93s when we kept the sources and only blanked preload, and 77.47s
         when load() was skipped entirely.
         data-src is preserved, so this is fully reversible — loadVideoSources() puts
         the src back on the next legitimate activation (tap, hover, or visibility),
         which is the ONLY way this card restarts. There is deliberately no automatic
         resume when the modal closes. */
      v.querySelectorAll('source[src]').forEach(function (s) {
        if (!s.getAttribute('data-src')) s.setAttribute('data-src', s.getAttribute('src'));
        s.removeAttribute('src');
      });
      v._sourcesLoaded = false;
      v.preload = 'none';
      try { v.load(); } catch (e) {}
    }

    function releaseAllInline(except) {
      track.querySelectorAll('.ugcv__video').forEach(function (v) {
        if (v !== except) releaseVideo(v);
      });
    }

    /* Generation-safe playback with a retry that can never revive a stale player.
       The old version caught EVERY rejection and re-armed on canplay with no
       ownership check, so a retry could fire seconds later and restart a card the
       user had already swiped away from or replaced by opening the modal. */
    function playWithRetry(v, tok) {
      if (!v || !isCurrent(tok)) return;
      dbg('play:req', v);
      var p = v.play();
      if (!p || typeof p.catch !== 'function') return;
      p.catch(function (err) {
        var name = (err && err.name) || 'Unknown';
        dbg('play:reject', v, name);
        if (!isCurrent(tok)) return;                 /* ownership moved on — do nothing */
        /* Only startup failures that a later canplay can actually fix are retried.
           NotAllowedError is an autoplay-policy block (needs a gesture, not data)
           and NotSupportedError is terminal. */
        if (name === 'NotAllowedError')  { OWNER.state = 'error'; return; }
        if (name === 'NotSupportedError') { OWNER.state = 'error'; return; }
        if (v._ugcvRetry) v.removeEventListener('canplay', v._ugcvRetry);
        var retry = function () {
          v.removeEventListener('canplay', retry);
          if (v._ugcvRetry === retry) v._ugcvRetry = null;
          if (!isCurrent(tok)) { dbg('retry:stale', v); return; }
          if (document.visibilityState === 'hidden') return;
          if (OWNER.role === 'inline' && modal && !modal.hasAttribute('hidden')) return;
          dbg('retry:go', v);
          v.play().catch(function () {});
        };
        v._ugcvRetry = retry;
        v.addEventListener('canplay', retry);
      });
    }

    /* Claim ownership for an inline card and start it. */
    function activateInline(video) {
      if (!video) return;
      if (OWNER.video === video && OWNER.role === 'inline') {
        /* Idempotent for the already-active card: repeated settle/scrollend
           triggers used to re-run the load path and churn the element
           (play → emptied → play → stale pause = frozen preview). */
        if (video.paused && !video.ended) playWithRetry(video, video._ugcvToken);
        return;
      }
      if (OWNER.video && OWNER.video !== video) releaseVideo(OWNER.video);
      var tok = setOwner(video, 'inline', 'inline-starting');
      video.muted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      loadVideoSources(video);
      /* NETWORK_NO_SOURCE recovery (unchanged behaviour, now in one place): if
         play() was attempted while the <source> elements still had no src, the
         element latches at networkState 3 and attaching src afterwards does not
         restart it — only load() re-runs resource selection. */
      if (video.networkState === 3 && video.querySelectorAll('source[src]').length) {
        try { video.load(); } catch (e) {}
      } else if (video.readyState === 0 && video.networkState !== 2) {
        video.preload = 'auto';
        try { video.load(); } catch (e) {}
      } else if (video.preload === 'none') {
        video.preload = 'auto';
      }
      assertNoDuplicateAsset(video);
      playWithRetry(video, tok);
    }

    /* Claim ownership for a modal slide. Every inline player is RELEASED first —
       pause() alone left the card copy of the same asset pulling HLS segments
       while the modal copy started, which is the duplicate-download bug. */
    function activateModal(video) {
      if (!video) return null;
      if (OWNER.video && OWNER.video !== video) releaseVideo(OWNER.video);
      releaseAllInline(null);
      var tok = setOwner(video, 'modal', 'modal-starting');
      assertNoDuplicateAsset(video);
      return tok;
    }

    /* State promotion: 'playing' is the only thing that moves *-starting to
       *-playing, so the watchdog and the prewarm gate read a real signal. */
    root.addEventListener('playing', function (e) {
      var v = e.target;
      if (!v || v.tagName !== 'VIDEO') return;
      if (OWNER.video !== v) return;
      OWNER.state = OWNER.role === 'modal' ? 'modal-playing' : 'inline-playing';
      dbg('playing', v);
    }, true);

    /* Tab backgrounded: release the owner outright. A hidden tab cannot be
       watching anything, and leaving an HLS fetch running there is pure waste. */
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState !== 'hidden') return;
      if (OWNER.video) { dbg('hidden:release', OWNER.video); releaseVideo(OWNER.video); }
      releaseAllInline(null);
      setOwner(null, null, 'idle');
    });

    /* ── Watchdog — ownership-aware ─────────────────────────────────────────
       It may recover a genuinely interrupted preview (engine power-saving, an
       interrupted play() promise), but it must never restart something that was
       deliberately stopped. Previously it retried whenever activeVideo was paused
       and visible, with no knowledge of whether the modal had opened, the tab had
       been backgrounded, or the video had just been released — so it fought every
       deliberate stop. It also may not attach sources or claim ownership itself. */
    setInterval(function () {
      if (OWNER.role !== 'inline') return;              /* modal owns media, or idle */
      var v = OWNER.video;
      if (!v || v.ended || !v.paused) return;
      if (OWNER.state === 'releasing' || OWNER.state === 'error') return;
      if (document.visibilityState === 'hidden') return;
      if (modal && !modal.hasAttribute('hidden')) return;
      if (!v._ugcvToken || !isCurrent(v._ugcvToken)) return;
      if (v.error) return;                              /* terminal */
      if (!v.querySelectorAll('source[src]').length && !v.getAttribute('src')) return;
      var r = v.getBoundingClientRect();
      if (r.width === 0) return;
      var _wsec = v.closest('.shopify-section');
      if (window.koreVisibleRatio && _wsec &&
          window.koreVisibleRatio(_wsec) < (window.KORE_VIDEO_IN_RATIO || 0.6)) return;
      v.muted = true;
      if (v.preload === 'none') v.preload = 'auto';
      /* NETWORK_NO_SOURCE after valid sources were attached: recover explicitly. */
      if (v.networkState === 3 && v.querySelectorAll('source[src]').length) {
        try { v.load(); } catch (e) {}
      }
      dbg('watchdog', v);
      playWithRetry(v, v._ugcvToken);
    }, 1500);

    /* Kept as the section's public name for a full stop; every former caller of
       the old deactivateVideo() wanted a release, not a pause. */
    function deactivateVideo(v) {
      if (!v) return;
      if (OWNER.video === v) setOwner(null, null, 'idle');
      releaseVideo(v);
    }

    /* ── Desktop hover autoplay ──────────────────────────────────────────── */
    if (hoverAP) {
      track.querySelectorAll('.ugcv__card').forEach(function (card) {
        var video = card.querySelector('.ugcv__video');
        var icon  = card.querySelector('.ugcv__play-icon');
        if (!video) return;

        card.addEventListener('mouseenter', function () {
          if (window.innerWidth < 750) return;

          /* Hover-to-play goes through the same owner as every other path, so
             moving between cards releases the previous one's fetch instead of
             leaving it downloading behind the new hover. Behaviour is unchanged:
             one card plays, the icon hides, leaving restores the poster. */
          if (OWNER.video && OWNER.video !== video) releaseVideo(OWNER.video);
          var tok = setOwner(video, 'inline', 'inline-starting');

          video.muted = true;
          if (icon) icon.classList.add('is-hidden');

          function doPlay() {
            if (!isCurrent(tok)) return;   /* cursor already moved to another card */
            video.play().catch(function () {
              if (icon) icon.classList.remove('is-hidden');
            });
          }

          loadVideoSources(video);
          assertNoDuplicateAsset(video);

          if (video.readyState === 0) {
            video._hoverPlay = doPlay;
            video.addEventListener('canplay', doPlay, { once: true });
            video.preload = 'auto';
            video.load();
          } else {
            doPlay();
          }
        });

        card.addEventListener('mouseleave', function () {
          /* Full release, not a bare pause: a hovered-then-left card kept pulling
             segments while the next hovered card started. Clearing ownership
             first makes the pause listener treat this as a real deactivation and
             restore the poster instantly. */
          if (OWNER.video === video) setOwner(null, null, 'idle');
          releaseVideo(video);
        });
      });
    }

    /* ── Mobile touch-to-play: tap opens modal, swipe scrolls carousel ──────────
       On mobile, touchend opens the modal directly (trusted user gesture on iOS Safari).
       suppressNextMobileClick prevents the synthetic click that follows the touch
       sequence from double-opening the modal. Desktop uses the click event instead. */
    var suppressNextMobileClick = false;
    (function () {
      track.querySelectorAll('.ugcv__card').forEach(function (card) {
        var video = card.querySelector('.ugcv__video');
        if (!video) return;

        var _touchStartX    = 0;
        var _touchStartY    = 0;
        var _touchMoved     = false;
        var _touchStartTime = 0;

        card.addEventListener('touchstart', function (e) {
          _touchMoved     = false;
          _touchStartTime = Date.now();
          var t = e.touches[0];
          _touchStartX = t ? t.clientX : 0;
          _touchStartY = t ? t.clientY : 0;

          /* Mobile: start the muted inline preview from this user gesture.
             Muted + playsinline is always allowed on iOS Safari inside touchstart.
             On desktop a touch is not the play trigger (hover is), so only claim
             ownership there without starting playback. */
          if (window.innerWidth < 750) {
            activateInline(video);
          } else {
            if (OWNER.video && OWNER.video !== video) releaseVideo(OWNER.video);
            setOwner(video, 'inline', 'inline-starting');
            video.muted = true;
            loadVideoSources(video);
          }

          /* The modal video is deliberately NOT prewarmed here.
             It used to be: touchstart started the inline card AND loaded the modal
             copy of the same asset at preload='metadata'. A quick tap then opened
             the modal ~200ms later, so two <video> elements for ONE Shopify asset
             had live HLS traffic, and openModal only pause()d the card — which does
             not abort a fetch. The modal player now receives sources when the modal
             actually opens, after the inline player has been fully released. */
        }, { passive: true });

        card.addEventListener('touchmove', function (e) {
          if (_touchMoved) return;
          var t = e.touches[0];
          if (!t) return;
          var dx = t.clientX - _touchStartX;
          var dy = t.clientY - _touchStartY;
          if (dx * dx + dy * dy > 400) _touchMoved = true; /* 20 px radius */
        }, { passive: true });

        card.addEventListener('touchend', function () {
          if (window.innerWidth >= 750) return; /* desktop: click event handles modal */

          /* Always suppress the synthetic click that follows any mobile touch —
             covers quick taps, holds, and swipes so the click never double-opens. */
          suppressNextMobileClick = true;
          setTimeout(function () { suppressNextMobileClick = false; }, 500);

          if (_touchMoved) return; /* swipe — carousel scroll only */

          var touchDuration = Date.now() - _touchStartTime;
          if (touchDuration > 220) return; /* hold/preview — inline only, not modal */

          /* Mobile quick tap: open modal directly from touchend (trusted iOS Safari gesture). */
          if (modalOn && modal && feed) {
            openModal(parseInt(card.dataset.ugcvIdx, 10) || 0, card.querySelector('.ugcv__media'));
          } else {
            /* Modal disabled — fall back to inline muted play */
            if (activeVideo === video) video.play().catch(function () {});
          }
        });

        card.addEventListener('touchcancel', function () {
          deactivateVideo(video);
        }, { passive: true });
      });

      /* Touch anywhere outside the carousel: the inline preview is no longer what
         the user is looking at, so release it rather than leaving it downloading.
         Never fires while the modal owns media. */
      document.addEventListener('touchstart', function (e) {
        if (OWNER.role !== 'inline' || !OWNER.video) return;
        if (e.target.closest && e.target.closest('.ugcv__card')) return;
        deactivateVideo(OWNER.video);
      }, { passive: true });
    })();

    /* ── Mobile scroll-settle preview: after carousel swipe settles, preview the centered card ─ */
    (function () {
      var _settleTimer;
      track.addEventListener('scroll', function () {
        if (window.innerWidth >= 750) return; /* mobile only */
        if (!mobileAP) return; /* "Autoplay on mobile" setting off → no auto preview */
        clearTimeout(_settleTimer);
        _settleTimer = setTimeout(function () {
          /* Skip if modal is open */
          if (modal && !modal.hasAttribute('hidden')) return;
          /* Find the card whose center is closest to the track's visible center */
          var trackRect    = track.getBoundingClientRect();
          /* The RTL init scroll (scrollLeft = scrollWidth) and the arrow polarity
             probe fire synthetic 'scroll' events at page load while this section
             can be thousands of px below the fold — settling then downloads and
             plays a full video during initial page load (live-probe: card video
             loading at t≈5s, 2400px below fold, starving the page's own media).
             Only settle-play when the track is actually on screen. */
          if (trackRect.bottom <= 0 || trackRect.top >= window.innerHeight) return;
          var trackCenterX = trackRect.left + trackRect.width / 2;
          var bestCard = null;
          var bestDist = Infinity;
          track.querySelectorAll('.ugcv__card').forEach(function (c) {
            var rect = c.getBoundingClientRect();
            var dist = Math.abs((rect.left + rect.width / 2) - trackCenterX);
            if (dist < bestDist) { bestDist = dist; bestCard = c; }
          });
          if (!bestCard) return;
          var cv = bestCard.querySelector('.ugcv__video');
          if (!cv || cv === OWNER.video) return; /* already previewing this card */
          if (OWNER.role === 'modal') return;    /* the modal owns media right now */
          activateInline(cv);
        }, 300);
      }, { passive: true });
    })();

    /* ── Mobile prewarm: prepare the FIRST visible video when section enters viewport ─
       Gated on mobileAP: prewarming exists only to make the mobile auto-preview start
       instantly, so it is pointless when the setting is off. (mobileAP was previously
       read but never used — the "Autoplay on mobile" control did nothing.) */
    if (mobileAP && 'IntersectionObserver' in window) {
      var mobilePrewarmDone = false;
      var runApproachPrewarm = function () {
        if (mobilePrewarmDone) return;
        mobilePrewarmDone = true;

        /* (1) Posters: force-load ALL card posters, one request at a time.
           The shared gate's 300px horizontal margin covers only ~1 card ahead
           in the carousel, so cards 2+ used to fetch their poster mid-swipe —
           the user-reported grey boxes on every swipe. The sequential chain
           keeps this from bursting 8 concurrent image requests. */
        var posters = Array.prototype.slice.call(track.querySelectorAll('.ugcv__poster-img[data-kore-gate-src]'));
        var loadNextPoster = function () {
          var img = posters.shift();
          if (!img) return;
          if (img.currentSrc || !window.koreGateLoadNow) { loadNextPoster(); return; }
          var done = false;
          var next = function () { if (done) return; done = true; loadNextPoster(); };
          img.addEventListener('load',  next, { once: true });
          img.addEventListener('error', next, { once: true });
          setTimeout(next, 1200); /* chain never stalls on a dropped request */
          window.koreGateLoadNow(img);
        };
        loadNextPoster();

        /* (2) Phase C: prewarm only the first card's video — caps concurrent
           video downloads at 1 on mobile */
        var prewarmCount = 0;
        track.querySelectorAll('.ugcv__card').forEach(function (c) {
          if (prewarmCount >= 1) return;
          if (c.hasAttribute('data-ugcv-clone')) return; /* clones are duplicates of real cards */
          var cv = c.querySelector('.ugcv__video');
          if (!cv) return;
          /* MEASURED BUG (fixed): the budget used to be spent only when a card was
             actually warmed, so a first card that was ALREADY source-loaded fell
             through and card 2 got prewarmed as well — two concurrent video
             downloads instead of one. That happens on slow links, where window
             'load' (which arms this observer) lands AFTER the autoplay observer has
             already called loadVideoSources() on card 1. Card 2 then buffered to
             readyState 4 while card 1 — the card actually told to play — sat at
             readyState 0 with paused:false, i.e. a permanently stalled first video.
             Observed on 1.6Mbps: card 2 pulled 1 713KB, card 1 pulled 0.
             The first real card now consumes the budget whether or not it needed
             warming, so exactly one card is ever prewarmed. */
          prewarmCount++;
          if (cv._sourcesLoaded) return; /* already warm — budget spent, nothing to do */
          /* Never prewarm behind an owner: if a card is already playing or the
             modal is open, this speculative fetch would be the second consumer on
             the link — the exact contention this refactor removes. */
          if (OWNER.video) return;
          if (modal && !modal.hasAttribute('hidden')) return;
          {
            loadVideoSources(cv);
            /* 'auto' (was 'metadata'): metadata only fetched the HLS manifest, so
               play-on-arrival still had to download every segment from scratch —
               measured 3.5s poster-to-first-frame on 4G. 'auto' lets the browser
               buffer a few seconds during the approach and then suspend; only the
               FIRST card, only within 900px, only after window load. */
            cv.preload = 'auto';
            cv.load();
          }
        });
      };
      /* Approach observer: 900px vertical head start (the old threshold:0.1
         fired only once the track was already ON screen — zero head start;
         live-probe: first video began loading at arrival and stalled ~4s on 4G).
         Armed after window load so the shorter pre-media layout cannot fire it
         for a section still far below the fold, and so the prewarm bytes never
         compete with the initial page load. */
      var armPrewarmObs = function () {
        if (mobilePrewarmDone || window.innerWidth >= 750) return;
        var prewarmObs = new IntersectionObserver(function (entries) {
          if (window.innerWidth >= 750) return;
          var entry = entries[entries.length - 1];
          if (entry.isIntersecting) {
            if (!mobilePrewarmDone) runApproachPrewarm();
          } else if (mobilePrewarmDone) {
            /* Scrolled past without stopping: the preload='auto' prewarm keeps
               buffering while the user is already at ANOTHER section's video
               (live probe: UGC segments competing with the product page's
               media-text video). Abort the fetch if no card is active and
               nothing has rendered yet; autoObs/touch re-load on return. */
            var fv = track.querySelector('.ugcv__video');
            if (fv && !activeVideo && fv.readyState === 0 && fv.networkState === 2) {
              fv.preload = 'none';
              fv.load();
            }
            prewarmObs.disconnect();
          }
        }, { rootMargin: '900px 0px', threshold: 0 });
        prewarmObs.observe(track);
      };
      if (document.readyState === 'complete') armPrewarmObs();
      else window.addEventListener('load', armPrewarmObs, { once: true });
    }

    /* ── Card spinner + in-view autoplay ─────────────────────────────────────
       The card that is centred in the carousel plays automatically instead of
       waiting for a tap. Only ONE plays: the global coordinator in theme.liquid
       pauses every other opted-in video, so this does not reintroduce the
       simultaneous-download problem. The spinner shows only while we are genuinely
       waiting for data, so a slow connection reads as "loading", not "broken". */
    (function () {
      var cards = track.querySelectorAll('.ugcv__card');
      cards.forEach(function (card) {
        var v  = card.querySelector('.ugcv__video');
        var sp = card.querySelector('[data-ugcv-spinner]');
        if (!v) return;
        if (sp) {
          /* ── Spinner = "this video was told to play and is genuinely stuck" ──
             The previous binding mapped events straight to show/hide:
               waiting|loadstart|stalled -> show ; playing|canplay|error|pause -> hide
             which left the spinner burned onto a HAPPILY PLAYING video. 'stalled'
             fires whenever no data arrives for ~3s, and HLS fires it routinely
             mid-playback while the element plays on from its buffer — and after
             that only 'playing' would hide it, which does NOT fire again unless a
             'waiting' preceded it. Measured on the live homepage: card 1 logged
             `playing @8288ms` then `stalled @11737ms`, and the spinner sat at
             opacity 1 over a video with paused:false, readyState:4.
             It also showed on every load() (loadstart), including the source
             release/restore in kore-layout.js, with no matching hide.

             Now there is ONE derived predicate — "not paused AND readyState < 3" —
             re-evaluated on the whole lifecycle. 'timeupdate' is the key addition:
             it fires ~4x/second while frames are advancing, so a spinner can never
             outlive actual playback regardless of which event showed it.
             A 250ms delayed show absorbs short buffering blips; the hide is always
             immediate. */
          var SPIN_DELAY = 250;
          var spinTimer = null;
          var isStuck = function () { return !v.paused && v.readyState < 3; };
          var spinHide = function () {
            if (spinTimer) { clearTimeout(spinTimer); spinTimer = null; }
            sp.classList.remove('is-visible');
          };
          var spinEval = function () {
            if (!isStuck()) { spinHide(); return; }
            if (spinTimer || sp.classList.contains('is-visible')) return;
            spinTimer = setTimeout(function () {
              spinTimer = null;
              if (isStuck()) sp.classList.add('is-visible'); /* re-checked after the delay */
            }, SPIN_DELAY);
          };
          ['loadstart', 'waiting', 'stalled', 'suspend', 'progress',
           'canplay', 'canplaythrough', 'playing', 'play', 'timeupdate',
           'pause', 'ended', 'error', 'emptied', 'abort'
          ].forEach(function (evt) { v.addEventListener(evt, spinEval); });
          spinEval();
        }
      });

      if (!('IntersectionObserver' in window)) return;
      var autoObs = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          /* Desktop is hover-to-play ONLY (user directive): videos stay paused
             on their poster until the cursor enters a card; the mouseenter
             handler above owns play/pause handoff between cards. In-view
             autoplay is a mobile behavior, governed by "Autoplay on mobile". */
          if (window.innerWidth >= 750) return;
          if (!mobileAP) return;
          var card = entry.target;
          var v = card.querySelector('.ugcv__video');
          if (!v) return;
          /* Card must be 60% visible AND its section must still be the one on screen
             (window.KORE_VIDEO_IN_RATIO) — otherwise a card could start playing while
             the section itself is mostly gone. */
          var _sec = card.closest('.shopify-section') || track;
          var _ratioOK = !window.koreVisibleRatio ||
                         window.koreVisibleRatio(_sec) >= (window.KORE_VIDEO_IN_RATIO || 0.6);
          if (entry.isIntersecting && entry.intersectionRatio >= 0.6 && _ratioOK) {
            /* The modal owns media while it is open — an intersection callback
               firing behind it must not start a card downloading. */
            if (OWNER.role === 'modal') return;
            if (modal && !modal.hasAttribute('hidden')) return;
            /* One path now does source injection, NETWORK_NO_SOURCE recovery,
               preload promotion and the generation-safe play(). This callback used
               to do all of it inline, which is how a second card could start
               downloading while another card was still the active one. */
            activateInline(v);
          }
          /* Pausing is left to the coordinator so there is a single owner of that decision. */
        });
      }, { threshold: [0, 0.6, 1] });
      cards.forEach(function (c) { if (!c.hasAttribute('data-ugcv-clone')) autoObs.observe(c); });
    })();

    /* ── Modal / TikTok viewer ───────────────────────────────────────────── */
    if (!modalOn || !modal || !feed) return;

    var lastFocused   = null;
    var ignoreObs     = false;
    var isTeleporting = false;
    var currentMuted  = false;
    var _openGen      = 0; /* generation counter — stale 80ms modal timer guard */

    /* ── Speaker helper ─────────────────────────────────────────────────── */
    function setSpeakerMuted(slide, muted) {
      var btn = slide.querySelector('[data-ugcv-spk]');
      if (!btn) return;
      if (muted) {
        btn.setAttribute('aria-label', 'Unmute');
        btn.classList.add('is-muted');
      } else {
        btn.setAttribute('aria-label', 'Mute');
        btn.classList.remove('is-muted');
      }
    }

    /* ── Modal spinner: same derived-state model already approved for cards ──
       It used to map events straight to show/hide:
         waiting|loadstart|stalled -> show ; playing|canplay|error -> hide
       'stalled' fires routinely mid-playback while HLS plays on from its buffer,
       and only 'playing' would hide it again — which does NOT re-fire unless a
       'waiting' preceded it. That is the exact mapping already proven to burn the
       spinner onto a happily playing video on the cards.
       One derived predicate instead — "told to play and genuinely without data" —
       re-evaluated across the whole lifecycle. 'timeupdate' (~4x/s while frames
       advance) guarantees the spinner cannot outlive playback. */
    function bindModalSpinner(slide, vid) {
      var sp = slide.querySelector('[data-ugcvm-spinner]');
      if (!sp || vid._koreSpinBound) return;
      vid._koreSpinBound = true;
      var SPIN_DELAY = 250;
      var spinTimer = null;
      var isStuck = function () { return !vid.paused && vid.readyState < 3; };
      var spinHide = function () {
        if (spinTimer) { clearTimeout(spinTimer); spinTimer = null; }
        sp.classList.remove('is-visible');
      };
      var spinEval = function () {
        if (modal.hasAttribute('hidden')) { spinHide(); return; }
        if (!isStuck()) { spinHide(); return; }
        if (spinTimer || sp.classList.contains('is-visible')) return;
        spinTimer = setTimeout(function () {
          spinTimer = null;
          if (isStuck() && !modal.hasAttribute('hidden')) sp.classList.add('is-visible');
        }, SPIN_DELAY);
      };
      ['loadstart', 'waiting', 'stalled', 'suspend', 'progress',
       'canplay', 'canplaythrough', 'playing', 'play', 'timeupdate',
       'pause', 'ended', 'error', 'emptied', 'abort'
      ].forEach(function (evt) { vid.addEventListener(evt, spinEval); });
      vid._koreSpinEval = spinEval;   /* so close/release can force a re-evaluation */
      spinEval();
    }
    function hideModalSpinners() {
      feed.querySelectorAll('[data-ugcvm-spinner]').forEach(function (sp) {
        sp.classList.remove('is-visible');
      });
    }

    function releaseAllModal(except) {
      feed.querySelectorAll('.ugcv-modal__video').forEach(function (v) {
        if (v !== except) releaseVideo(v);
      });
    }

    /* ── Infinite loop: clone first & last slides once ──────────────────── */
    var realSlides    = Array.from(feed.querySelectorAll('.ugcv-modal__slide:not([data-ugcv-clone])'));
    var slideCount    = realSlides.length;
    var allSlides     = realSlides;
    var hasClonesFlag = false;

    if (slideCount > 1 && !feed.querySelector('[data-ugcv-clone]')) {
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone  = realSlides[slideCount - 1].cloneNode(true);
      firstClone.setAttribute('data-ugcv-clone', 'true');
      lastClone.setAttribute('data-ugcv-clone', 'true');
      feed.appendChild(firstClone);
      feed.insertBefore(lastClone, realSlides[0]);
    }
    if (slideCount > 1) hasClonesFlag = !!feed.querySelector('[data-ugcv-clone]');
    allSlides = Array.from(feed.querySelectorAll('.ugcv-modal__slide'));
    /* With clones: allSlides = [lastClone, real[0]…real[N-1], firstClone] */

    /* Card click → open modal */
    track.querySelectorAll('.ugcv__card').forEach(function (card) {
      var media = card.querySelector('.ugcv__media');
      if (!media) return;
      function doOpen() {
        /* Mobile: touchend already opened the modal and set suppressNextMobileClick.
           Swallow the synthetic click that fires from the same touch sequence. */
        if (window.innerWidth < 750 && suppressNextMobileClick) return;
        var idx = parseInt(card.dataset.ugcvIdx, 10) || 0;
        openModal(idx, media);
      }
      media.addEventListener('click', doOpen);
      media.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); doOpen(); }
      });
    });

    function openModal(idx, fromEl) {
      var myGen    = ++_openGen; /* capture this open's generation for stale-timer guard */
      lastFocused  = fromEl || null;
      ignoreObs    = true;
      currentMuted = false;

      /* RELEASE every inline card before the modal touches the network.
         This used to be a bare pause() loop, which does not abort an HLS fetch:
         the card copy of this very asset kept pulling segments while the modal
         copy started downloading, so one video was being fetched twice over one
         cellular link. Ownership is cleared first so the pause listeners restore
         the card posters. */
      /* Declare modal ownership on the section root BEFORE releasing the cards.
         kore-layout.js reads this attribute and stops treating inline UGC cards in
         this section as playable, which is what stops it re-activating a card
         behind the open modal (the coordinator picks by visible area, and an
         overlay does not change a card's bounding box). */
      root.setAttribute('data-ugcv-modal-open', 'true');
      setOwner(null, null, 'releasing');
      releaseAllInline(null);

      modal.removeAttribute('hidden');
      document.body.style.overflow = 'hidden';

      /* Target real slide only (skip clones that share the same data-ugcv-idx) */
      var target = feed.querySelector('[data-ugcv-idx="' + idx + '"]:not([data-ugcv-clone])');
      if (target) {
        feed.scrollTo({ top: target.offsetTop, behavior: 'instant' });

        var vid = target.querySelector('.ugcv-modal__video');
        if (vid) {
          /* Reuse the card thumbnail the browser has ALREADY downloaded as this video's poster.
             The markup poster is hard-coded to width:450, but the card's srcset makes the browser
             pick 900w on a DPR-3 phone — a different URL, so the modal poster was a cold fetch on
             an already-saturated link and the #000 wrapper showed through. currentSrc is whatever
             the card actually loaded, so this is a cache hit and paints immediately. */
          if (fromEl) {
            var _card    = fromEl.closest ? (fromEl.closest('.ugcv__card') || fromEl) : fromEl;
            var _cardImg = _card.querySelector ? _card.querySelector('.ugcv__poster-img') : null;
            if (_cardImg && _cardImg.currentSrc && _cardImg.naturalWidth > 0) {
              vid.poster = _cardImg.currentSrc;
              /* Paint it behind the video too, so there is never a black frame while decoding. */
              var _wrap = vid.parentElement;
              if (_wrap && _wrap.classList.contains('ugcv-modal__video-wrap')) {
                _wrap.style.backgroundImage = 'url("' + _cardImg.currentSrc + '")';
              }
            }
          }

          bindModalSpinner(target, vid);

          /* Claim ownership for the modal. activateModal() releases every inline
             player FIRST, so the card copy of this asset is off the wire before
             the modal copy gets its sources. */

          activateModal(vid);

          vid.muted  = false;
          vid.volume = 1;
          setSpeakerMuted(target, false);

          /* Sources are attached here, not at touchstart — see the note there. */
          if (vid.readyState === 0) {
            loadVideoSources(vid); /* inject data-src before load */
            vid.preload = 'auto';
            try { vid.load(); } catch (e) {}
          } else if (vid.preload === 'none') {
            vid.preload = 'auto';
          }
          assertNoDuplicateAsset(vid);

          /* play() synchronously inside the click handler — iOS Safari preserves the user
             gesture context here, so play() is permitted even while still buffering.
             On unmuted rejection (autoplay policy), retry muted; both run as microtasks
             within the same gesture checkpoint so the gesture context is still valid. */
          vid.play().catch(function () {
            if (OWNER.video !== vid) return;   /* modal moved on while we awaited */
            vid.muted = true;
            currentMuted = true;
            setSpeakerMuted(target, true);
            vid.play().catch(function () {});
          });
        }
      }

      setTimeout(function () {
        /* Abort if the modal was closed before this timer fired — avoids audio leak */
        if (modal.hasAttribute('hidden')) { ignoreObs = false; return; }
        /* Abort if a newer openModal call has since fired — prevents wrong-slide audio */
        if (myGen !== _openGen) { ignoreObs = false; return; }
        if (target) {
          var vid2 = target.querySelector('.ugcv-modal__video');
          if (vid2 && vid2.paused && vid2.readyState >= 1) {
            vid2.muted  = currentMuted;
            vid2.volume = currentMuted ? vid2.volume : 1;
            vid2.play().catch(function () {});
            setSpeakerMuted(target, currentMuted);
          }
        }
        ignoreObs = false;
      }, 80);

      var closeBtn = modal.querySelector('.ugcv-modal__close');
      if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
      ignoreObs = false;
      /* Release, not pause: a closed modal's video is no longer relevant, and a
         paused HLS element keeps fetching. This also clears ownership so the
         inline carousel can take over again on the next scroll-settle/hover. */
      setOwner(null, null, 'releasing');
      releaseAllModal(null);
      hideModalSpinners();
      modal.setAttribute('hidden', '');
      document.body.style.overflow = '';
      setOwner(null, null, 'idle');
      /* Inline eligibility resumes only after the modal is fully closed and this
         component has cleared ownership — the coordinator never re-enters on its
         own while the flag is set. */
      root.removeAttribute('data-ugcv-modal-open');
      /* DELIBERATELY NO AUTOMATIC INLINE RESTART (product decision).
         The opener card stays paused and released after close: no activateInline(),
         no source re-injection, no load(), no play(). releaseVideo() has already
         restored the poster overlay and play icon, so the card is visually intact
         and interactive. The next legitimate trigger — tap, desktop hover, or the
         existing visibility activation — goes through activateInline(), which
         re-injects sources when needed (required by release strategy C, whose
         sources are detached) and starts exactly that one card. */
      if (lastFocused) lastFocused.focus();
    }

    /* Retained name; now a real release so a slide the user has left cannot keep
       competing with the slide they are on. */
    function pauseAll() {
      releaseAllModal(OWNER.role === 'modal' ? OWNER.video : null);
    }

    /* Borrow the carousel card's ALREADY-LOADED poster for a modal slide: paints
       the wrap background (visible instantly, cache hit) and arms the crossfade —
       the video stays transparent until its first frame is presented. Same trick
       openModal uses for the entry slide, generalized for every slide change. */
    function applySlidePoster(slide) {
      var vid = slide.querySelector('.ugcv-modal__video');
      if (!vid || vid._koreBgApplied) return;
      var idx  = slide.dataset.ugcvIdx;
      var card = idx != null ? track.querySelector('.ugcv__card[data-ugcv-idx="' + idx + '"]') : null;
      var img  = card ? card.querySelector('.ugcv__poster-img') : null;
      if (!img) return;
      var loaded = img.currentSrc && img.naturalWidth > 0;
      /* Cards beyond the gate margin never loaded their poster (user-reported:
         deep slides like Doze still blinked grey). Fall back to the gate URL for
         the wrap background — the browser fetch starts now, shared with the card
         image which we force-load through the utility (same URL, one request). */
      var url = loaded ? img.currentSrc : (img.dataset ? img.dataset.koreGateSrc : null);
      if (!url) return;
      if (!loaded && window.koreGateLoadNow) window.koreGateLoadNow(img);
      vid._koreBgApplied = true;
      if (!vid.getAttribute('poster')) vid.poster = url;
      var wrap = vid.parentElement;
      if (wrap && wrap.classList.contains('ugcv-modal__video-wrap')) {
        wrap.style.backgroundImage = 'url("' + url + '")';
        wrap.style.backgroundSize = 'cover';
        wrap.style.backgroundPosition = 'center';
        vid.classList.add('ugcvm-has-bg');
        /* Already mid-playback (the entry slide): reveal immediately — there may
           be no future 'playing' event to do it. */
        if (!vid.paused && vid.readyState >= 2) vid.classList.add('is-framed');
        if (!vid._koreFrameBound) {
          vid._koreFrameBound = true;
          vid.addEventListener('playing', function () {
            var reveal = function () { vid.classList.add('is-framed'); };
            if (vid.requestVideoFrameCallback) vid.requestVideoFrameCallback(reveal);
            setTimeout(reveal, 250); /* rVFC fallback (headless/battery-saver) */
          });
        }
      }
    }

    /* ── Adjacent-slide preparation ────────────────────────────────────────
       This used to attach sources and call load() on BOTH neighbours, 400ms after
       the active slide started. Three modal videos could then be consuming the
       link at once, and a 400ms timer is not evidence that the active one is
       stable — on 1.6Mbps it is usually still buffering its first segment.

       Media prewarm is now OFF by default (MODAL_PREWARM_MEDIA) so its effect can
       be measured rather than assumed. Posters are still prepared, in both
       directions: an image is far cheaper than an HLS ladder and it is what stops
       the reported grey blink on swipe.

       When enabled, it prepares ONE slide, in the direction the user is actually
       moving, and only after sustained playback is proven — not a timeout. */
    var MODAL_PREWARM_MEDIA = false;
    var lastNavDir = 1;   /* +1 = forward through the feed, -1 = backward */

    function prepareSlidePosters(slide) {
      var i = realSlides.indexOf(slide);
      if (i === -1) return;
      [realSlides[i - 2], realSlides[i - 1], realSlides[i + 1], realSlides[i + 2]]
        .forEach(function (s) { if (s) applySlidePoster(s); });
    }

    /* Sustained playback: a 'playing' event is not enough — it fires before frames
       necessarily keep coming. This requires currentTime to advance by at least
       0.5s across several samples while the video still owns the modal. */
    function onSustainedPlayback(video, tok, cb) {
      var start = null, advanced = 0, samples = 0;
      var tick = function () {
        if (!isCurrent(tok)) { cleanup(); return; }
        if (document.visibilityState === 'hidden') { cleanup(); return; }
        if (video.paused) return;
        if (start === null) { start = video.currentTime; return; }
        var d = video.currentTime - start;
        if (d > 0) samples++;
        advanced = d;
        if (advanced >= 0.5 && samples >= 3) { cleanup(); cb(); }
      };
      var timer = setInterval(tick, 150);
      var cleanup = function () { clearInterval(timer); video.removeEventListener('timeupdate', tick); };
      video.addEventListener('timeupdate', tick);
      setTimeout(cleanup, 15000);   /* never leaks if the video never stabilises */
    }

    function prewarmForwardSlide(slide, tok) {
      if (!MODAL_PREWARM_MEDIA) return;
      if (document.visibilityState === 'hidden') return;
      var i = realSlides.indexOf(slide);
      if (i === -1) return;
      var next = realSlides[i + (lastNavDir >= 0 ? 1 : -1)];
      if (!next) return;
      var v = next.querySelector('.ugcv-modal__video');
      if (!v || v._sourcesLoaded) return;
      if (!isCurrent(tok)) return;              /* the active slide changed */
      loadVideoSources(v);
      if (v.preload === 'none') v.preload = 'metadata';
      if (v.readyState === 0 && v.networkState !== 2) { try { v.load(); } catch (e) {} }
      dbg('prewarm:next', v);
    }

    function playSlide(slide) {
      var video = slide.querySelector('.ugcv-modal__video');
      if (!video) return;
      /* Direction of travel, for the forward-only prewarm. */
      var prevIdx = realSlides.indexOf(OWNER.role === 'modal' && OWNER.video
        ? OWNER.video.closest('.ugcv-modal__slide') : null);
      var thisIdx = realSlides.indexOf(slide);
      if (prevIdx !== -1 && thisIdx !== -1 && prevIdx !== thisIdx) {
        lastNavDir = thisIdx > prevIdx ? 1 : -1;
      }

      /* Claim ownership, which releases the previous slide AND any inline card.
         The old code called pauseAll() — pause does not abort an HLS fetch, so
         the slide the user had just swiped away from kept downloading. */
      var tok = activateModal(video);
      releaseAllModal(video);
      bindModalSpinner(slide, video);
      applySlidePoster(slide);
      prepareSlidePosters(slide);
      video.muted  = currentMuted;
      video.volume = currentMuted ? video.volume : 1;
      setSpeakerMuted(slide, currentMuted);

      function doPlaySlide() {
        if (modal.hasAttribute('hidden')) return; /* modal closed while video was buffering */
        if (!isCurrent(tok)) return;              /* the user moved to another slide */
        video.play().catch(function () {
          if (!isCurrent(tok)) return;
          video.muted = true;
          currentMuted = true;
          video.play().catch(function () {});
          setSpeakerMuted(slide, true);
        });
      }

      if (video.readyState === 0) {
        loadVideoSources(video); /* inject data-src before load */
        if (video._ugcvSlidePlay) video.removeEventListener('canplay', video._ugcvSlidePlay);
        video._ugcvSlidePlay = doPlaySlide;
        video.addEventListener('canplay', doPlaySlide, { once: true });
        video.preload = 'auto';
        try { video.load(); } catch (e) {}
      } else {
        video.preload = 'auto';
        doPlaySlide();
      }
      assertNoDuplicateAsset(video);
      /* Was: a blind 400ms timer warming BOTH neighbours. Now the forward
         neighbour only, and only once this slide is genuinely sustaining
         playback (and only when MODAL_PREWARM_MEDIA is enabled at all). */
      onSustainedPlayback(video, tok, function () {
        if (modal.hasAttribute('hidden')) return;
        prewarmForwardSlide(slide, tok);
      });
    }

    /* IntersectionObserver — only real slides (clones are never observed) */
    if ('IntersectionObserver' in window) {
      var feedObs = new IntersectionObserver(function (entries) {
        if (ignoreObs) return;
        entries.forEach(function (entry) {
          if (entry.isIntersecting && entry.intersectionRatio >= 0.55) {
            playSlide(entry.target);
          }
        });
      }, { root: feed, threshold: 0.55 });
      realSlides.forEach(function (s) { feedObs.observe(s); });
    }

    /* Speaker — event delegation works on real slides and clones alike */
    feed.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ugcv-spk]');
      if (!btn) return;
      e.stopPropagation();
      var slide = btn.closest('.ugcv-modal__slide');
      if (!slide) return;
      var video = slide.querySelector('.ugcv-modal__video');
      if (!video) return;
      currentMuted = !video.muted;
      video.muted  = currentMuted;
      setSpeakerMuted(slide, currentMuted);
    });

    /* Close button */
    modal.querySelector('.ugcv-modal__close').addEventListener('click', closeModal);

    /* ── Infinite-loop nav ───────────────────────────────────────────────── */
    function currentSlideIndex() {
      var slideH = feed.clientHeight || 1;
      var raw = Math.round(feed.scrollTop / slideH);
      /* With clones allSlides[0] is lastClone, so real index = raw − 1 */
      return hasClonesFlag ? raw - 1 : raw;
    }

    function goToSlide(realIdx) {
      var wrapped = ((realIdx % slideCount) + slideCount) % slideCount;
      var curIdx  = currentSlideIndex();
      var target;

      if (hasClonesFlag) {
        /* Edge transitions scroll into the adjacent clone (one slide away)
           instead of teleporting across the entire feed */
        if (curIdx === slideCount - 1 && wrapped === 0) {
          target = allSlides[slideCount + 1]; /* firstClone, just below last real */
        } else if (curIdx === 0 && wrapped === slideCount - 1) {
          target = allSlides[0];              /* lastClone, just above first real */
        } else {
          target = allSlides[wrapped + 1];
        }
      } else {
        target = allSlides[wrapped];
      }

      if (!target) return;
      feed.scrollTo({ top: target.offsetTop, behavior: 'smooth' });
    }

    /* After any scroll settles on a clone, silently teleport to the real slide */
    function handleScrollEnd() {
      if (isTeleporting || !hasClonesFlag) return;
      var lastCloneEl  = allSlides[0];
      var firstCloneEl = allSlides[slideCount + 1];
      if (!lastCloneEl || !firstCloneEl) return;

      var atLastClone  = Math.abs(feed.scrollTop - lastCloneEl.offsetTop)  < 20;
      var atFirstClone = Math.abs(feed.scrollTop - firstCloneEl.offsetTop) < 20;

      if (atLastClone) {
        isTeleporting = true;
        ignoreObs     = true;
        var realLast  = allSlides[slideCount];
        feed.scrollTo({ top: realLast.offsetTop, behavior: 'instant' });
        playSlide(realLast);
        setTimeout(function () { isTeleporting = false; ignoreObs = false; }, 80);
      } else if (atFirstClone) {
        isTeleporting = true;
        ignoreObs     = true;
        var realFirst = allSlides[1];
        feed.scrollTo({ top: realFirst.offsetTop, behavior: 'instant' });
        playSlide(realFirst);
        setTimeout(function () { isTeleporting = false; ignoreObs = false; }, 80);
      }
    }

    /* scrollend fires after snap animation; fall back to debounced scroll */
    if ('onscrollend' in window) {
      feed.addEventListener('scrollend', handleScrollEnd, { passive: true });
    } else {
      var scrollEndTimer;
      feed.addEventListener('scroll', function () {
        clearTimeout(scrollEndTimer);
        scrollEndTimer = setTimeout(handleScrollEnd, 150);
      }, { passive: true });
    }

    var navUp   = modal.querySelector('.ugcv-modal__nav--up');
    var navDown = modal.querySelector('.ugcv-modal__nav--down');
    if (navUp)   { navUp.addEventListener('click',   function () { goToSlide(currentSlideIndex() - 1); }); }
    if (navDown) { navDown.addEventListener('click', function () { goToSlide(currentSlideIndex() + 1); }); }

    /* Backdrop click */
    modal.addEventListener('pointerdown', function (e) {
      if (e.target === modal) closeModal();
    });

    /* Escape key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
    });
  }

  /* Boot — every instance on the page */
  function initAll() {
    var roots = document.querySelectorAll('[id^="ugcv-root-"]');
    for (var i = 0; i < roots.length; i++) {
      init(roots[i].id.replace('ugcv-root-', ''));
    }
  }
  if (document.readyState !== 'loading') { initAll(); }
  else { document.addEventListener('DOMContentLoaded', initAll); }

  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[id^="ugcv-root-"]');
      if (r) { r._ugcvInit = false; init(r.id.replace('ugcv-root-', '')); }
    });
  }
})();
